import { SEOSection } from '@/components';
import { ContentTypeName } from '@/constants';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { capitalize } from '@/utils';

export const PMTSeoSection = () => {
  const { pmtPageData } = useMyParcelsContext();
  const foundSeoSection = pmtPageData?.sectionList?.find(
    // biome-ignore lint/suspicious/noExplicitAny: Contentful section type is dynamic
    (section: any) => capitalize(section.__typename) === ContentTypeName.SeoSection,
  );

  if (!foundSeoSection) {
    return null;
  }

  return <SEOSection {...foundSeoSection} />;
};
